var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4973 12.3198C17.4049 10.8933 17.9255 9.01984 17.9255 7.17987C17.9255 3.76148 15.1433 0.980469 11.7259 0.980469C8.30859 0.980469 5.52843 3.76148 5.52843 7.17987C5.52843 8.94782 6.04411 10.8404 6.90776 12.2424C8.04088 14.0818 9.75203 15.0949 11.726 15.0949C13.6643 15.0949 15.3588 14.1093 16.4973 12.3198Z",
    fill: "url(#paint0_linear_6779_9907)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7097 27.0665L13.969 29.3893L13.7317 31.0317H3.52041C1.57926 31.0317 0 29.4515 0 27.5093V22.2495C0 18.5574 3.20074 15.5536 7.13501 15.5536H16.3188C20.2531 15.5536 23.4538 18.5574 23.4538 22.2495V22.3133L22.0134 19.5803C21.5938 18.7841 20.7741 18.2895 19.8741 18.2895C18.9741 18.2895 18.1543 18.7841 17.7348 19.5803L16.2247 22.4457L13.0313 22.9974C12.1444 23.1506 11.4208 23.7777 11.1433 24.633C10.865 25.489 11.0821 26.4216 11.7097 27.0665Z",
    fill: "url(#paint1_linear_6779_9907)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6414 24.8012C26.589 24.6398 26.4515 24.5206 26.2842 24.4917L22.14 23.7758L20.18 20.0567C20.1008 19.9065 19.945 19.8125 19.7753 19.8125C19.6055 19.8125 19.4497 19.9065 19.3706 20.0567L17.4105 23.7758L13.2664 24.4917C13.0991 24.5206 12.9616 24.6398 12.9091 24.8012C12.8567 24.9626 12.8979 25.1399 13.0163 25.2615L15.9487 28.2762L15.3477 32.4375C15.3234 32.6055 15.3942 32.7732 15.5315 32.873C15.669 32.9728 15.8501 32.9884 16.0025 32.9134L19.7753 31.0566L23.5482 32.9134C23.6121 32.9449 23.6813 32.9604 23.7501 32.9604C23.8451 32.9604 23.9395 32.9308 24.0191 32.873C24.1565 32.7732 24.2273 32.6055 24.2029 32.4375L23.6019 28.2762L26.5344 25.2615C26.6528 25.1398 26.6939 24.9626 26.6414 24.8012Z",
    fill: "#FFBA00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6779_9907",
    x1: 11.7269,
    y1: 0.980469,
    x2: 11.7269,
    y2: 31.0317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B8AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6779_9907",
    x1: 11.7269,
    y1: 0.980469,
    x2: 11.7269,
    y2: 31.0317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B8AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParty);
export default __webpack_public_path__ + "static/media/Party.957b50b93ec147421983607b84795f52.svg";
export { ForwardRef as ReactComponent };